import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Row, Col, Card, CardBody } from "reactstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { getUserAnalyticsList } from "services/appAnalytics.service";
import Spinner from "components/spinner";
import moment from "moment";

export const UserAnalyticsList = () => {
  const { SearchBar } = Search;
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    fetchUserAnalytics();
  }, []);

  const fetchUserAnalytics = async () => {
    setLoading(true);
    try {
      const res = await getUserAnalyticsList();

      if (res?.success) {
        const data = res?.data || [];
        console.log(data, "data");
        const formatted = data
          .filter(user => user._id !== null)
          .map(item => ({
            id: item._id._id,
            name: `${item._id.firstname} ${item._id.lastname}`,
            email: item._id.email,
            mobile: item._id.mobilenumber,
            createdAt: item._id.createdAt,
            count: item.count,
            lastActivityAt: item?.lastActivityAt,
          }))
          .sort(
            (a, b) =>
              new Date(b?.lastActivityAt || b?.createdAt) -
              new Date(a?.lastActivityAt || a?.createdAt)
          );
        // console.log(formatted, "item");
        setUserList(formatted);
      }
    } catch (error) {
      console.log("Error fetching user analytics", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      dataField: "lastActivityAt",
      text: "Last Activity",
      formatter: (cell, row) => {
        return (
          <div className="">
            {moment(row?.lastActivityAt).format("DD-MMM-YYYY")}
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: "Name",
    },
    {
      dataField: "email",
      text: "Email",
    },
    {
      dataField: "mobile",
      text: "Mobile",
    },
    {
      dataField: "count",
      text: "Total Clicks",
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "View Details",
      formatter: (_, row) => (
        <Link to={`/user-analytics/${row?.id}`}>
          <i className="mdi mdi-eye font-size-18 text-primary" />
        </Link>
      ),
    },
  ];

  const pageOptions = {
    sizePerPage: 10,
    totalSize: userList.length,
    custom: true,
  };

  return (
    <Card>
      <CardBody>
        <PaginationProvider
          pagination={paginationFactory(pageOptions)}
          keyField="id"
          columns={columns}
          data={userList}
        >
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField="id"
              data={userList}
              columns={columns}
              search
            >
              {toolkitProps => (
                <>
                  <Row className="mb-2">
                    <Col md="12">
                      <SearchBar
                        {...toolkitProps.searchProps}
                        placeholder="Search users..."
                      />
                    </Col>
                  </Row>

                  <BootstrapTable
                    bordered={false}
                    striped
                    {...toolkitProps.baseProps}
                    {...paginationTableProps}
                  />

                  <Row className="align-items-md-center mt-30">
                    <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                      <PaginationListStandalone {...paginationProps} />
                    </Col>
                  </Row>

                  {userList.length === 0 && !loading && (
                    <p className="text-center mt-3">No Active Users Found</p>
                  )}
                </>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
      </CardBody>
      <Spinner loading={loading} />
    </Card>
  );
};
